// extracted by mini-css-extract-plugin
export default {"variantIndicator":"VqrXWg4T1rkGPSL6Wopa","hasIcon":"RjY2We6FYhyt2j48Qsmc","icon":"LlyWSHWQ6dhwffeSFUnu","label":"hGbLzo7yXW8icFSkqgWn"};